<template>
	<div class="info-item">
		<div style="padding-bottom: 5px;display: flex;align-items: center;">
			<el-divider direction="vertical"></el-divider>
			<span>{{title}}</span>
		</div>
		<!-- <div style="padding-bottom: 5px;">
			<el-alert description="适用于企业、个体商户、事业单位等、通过营业执照、组织机构代码等"> </el-alert>
		</div> -->
		<div class="form-box" v-if="form">
			<el-form label-width="140px" ref="form" :model="form" size="small">
				<el-descriptions :column="2" :border="true" :colon="false" size="mini">
					<el-descriptions-item labelClassName="my-descriptions-label" contentClassName="my-descriptions-content" label="发票头">
						<span class="info-val">{{form.invoiceHead}}</span>
					</el-descriptions-item>
					<el-descriptions-item labelClassName="my-descriptions-label" contentClassName="my-descriptions-content" label="税务登记号">
						<span class="info-val">{{form.swDjh}}</span>
					</el-descriptions-item>
					<el-descriptions-item labelClassName="my-descriptions-label" contentClassName="my-descriptions-content" label="开户行">
						<span class="info-val">{{form.khhName}}</span>
					</el-descriptions-item>
					<el-descriptions-item labelClassName="my-descriptions-label" contentClassName="my-descriptions-content" label="开户行账号">
						<span class="info-val">{{form.khhNumber}}</span>
					</el-descriptions-item>
					<el-descriptions-item labelClassName="my-descriptions-label" contentClassName="my-descriptions-content" label="税务登记地址">
						<span class="info-val">{{form.swDjDz}}</span>
					</el-descriptions-item>
					<el-descriptions-item labelClassName="my-descriptions-label" contentClassName="my-descriptions-content" label="税务登记电话">
						<span class="info-val">{{form.swDjDh}}</span>
					</el-descriptions-item>
					<el-descriptions-item labelClassName="my-descriptions-label" contentClassName="my-descriptions-content" label="收票人邮箱">
						<span class="info-val">{{form.sprEmail}}</span>
					</el-descriptions-item>
					<el-descriptions-item labelClassName="my-descriptions-label" contentClassName="my-descriptions-content" label="收票人电话">
						<span class="info-val">{{form.sprDh}}</span>
					</el-descriptions-item>
				</el-descriptions>
			</el-form>
		</div>
		<div v-else class="no-info-box">请补充相关信息</div>
	</div>
</template>

<script>
	import constant from '@/api/commons.js'
	export default {
		name: "ShowYwInfo",
		computed: {
			currencyInfo:function(){
				return this.$store.getters['app/currencyInfo'];
			},
		},
		props:['title','form'],
		data() {
			return {
				imgHost:process.env.VUE_APP_BASE_API,
				tableData: [],
				qyTyoes: constant.qyTyoes,
				countrys: constant.country,
				count: 0,
				fileName: '',
				zcCurrencys: [],
			};
		},
		mounted() {
			console.log(this.currencyInfo)
		},
		methods: {
		}
	};
</script>
<style scoped="scoped">
</style>
